module.exports = "<div class=\"error-msg\" *ngIf=\"show\" [@errorAnimation]>\r\n  {{ msg }}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/input-error/input-error.component.html
// module id = ./libs/atenea-cms/src/input-error/input-error.component.html
// module chunks = main